import { render, staticRenderFns } from "./BlocoTabsMapaMonitoramentoAgricola.vue?vue&type=template&id=08d73df8&scoped=true&lang=pug"
import script from "./BlocoTabsMapaMonitoramentoAgricola.vue?vue&type=script&lang=js"
export * from "./BlocoTabsMapaMonitoramentoAgricola.vue?vue&type=script&lang=js"
import style0 from "./BlocoTabsMapaMonitoramentoAgricola.vue?vue&type=style&index=0&id=08d73df8&prod&lang=scss"
import style1 from "./BlocoTabsMapaMonitoramentoAgricola.vue?vue&type=style&index=1&id=08d73df8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d73df8",
  null
  
)

export default component.exports